import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { notificacionesSlice } from './slices/notificacionesSlice'

const useNotificacionesStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    uploadingImage: false,
    datos: {
        id:0,
        titulo:"",
        subtitulo:"",
        descripcion:"",
        tiene_contenido_detallado: false,
        imagen:"",
        imageKey:"",
        estatus:1,
        tipo:"sencilla",
        tipoId:"",
        tipoProgramacion:"inmediato",
        destinatarios:"todos",
    },
    tipos_notificacion: [],
    sucursales: [],
    preferencias: [],
    dispositivos: [],
    partidas: [],
    productos: [],
    handleSave: () => {
      get().insertarNotificacion();
    },
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    setImagePreview: (imagen) => set({ datos: { ...get().datos, imagen } }),
    setUploadingImage: (uploading) => set({ uploadingImage: uploading }),
    iniciar: async() => {    
        await get().obtenerOpcionesNotificacion();
        set({ isLoading: false });
    },
    limpiar: () => {
      set({
        isLoading: true,
        datos: {
          id:0,
          titulo:"",
          subtitulo:"",
          descripcion:"",
          tiene_contenido_detallado: false,
          imagen:"",
          imageKey:"",
          estatus:1,
          tipo:"sencilla",
          tipoId:"",
          tipoProgramacion:"inmediato",
          destinatarios:"todos",
        },
        elNavigate:null,
        error:null,
        uploadingImage: false,
      })
    },
    ...formularioSlice(set,get),
    ...notificacionesSlice(set,get),
}))
  
export default useNotificacionesStore
